import energeticImg from '../asset/img/energetic.png';
import leadershipImg from '../asset/img/leadership.jpeg';
import thinkingImg from '../asset/img/thinking_and_logic.jpg';
const aboutMe = {
    "name": "About Me",
    "data": [
        {
            "name": "Thinking & Logic",
            "description": "Quick research, fast learning, and logical thinking are my strengths. I can quickly grasp new concepts and apply them effectively in various situations.",
            "image": thinkingImg
        },
        {

            "name": "Leadership",
            "description": "Strong leadership skills and can effectively manage and motivate teams to achieve common goals.",
            "image": leadershipImg
        },
        {

            "name": "Energetic & Positive",
            "description": "Efficient cooperation and positive attitude, I can work well with others and contribute to a positive team environment.",
            "image": energeticImg
        }
    ]
}

export default aboutMe;